import { Link } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';

import { useGetClassPerformanceLowEnrollment } from '~entities/dashboard/api/get-class-performance-low-enrollment';

import { cn } from '~shared/shadcn/lib/utils';
import { Progress } from '~shared/shadcn/ui/progress';

interface LowEnrollmentTabProps {
  sessionId: string;
}

export const LowEnrollmentTab = ({ sessionId }: LowEnrollmentTabProps) => {
  const {
    data: lowEnrollmentClassesData,
    isLoading: isLowEnrollmentClassesLoading,
  } = useGetClassPerformanceLowEnrollment({
    sessionId,
  });

  return (
    <div>
      {/* <p className='mb-4 text-sm text-[#6B7280]'>
        Top 5 classes with lowest enrollment
      </p> */}
      {isLowEnrollmentClassesLoading ? (
        <div className='flex items-center justify-center py-6'>
          <Loader2 className='size-10 animate-spin' />
        </div>
      ) : lowEnrollmentClassesData?.length === 0 ? (
        <div className='py-6 text-center text-sm text-muted-foreground'>
          No Data found
        </div>
      ) : (
        <div>
          {lowEnrollmentClassesData?.map((classItem) => (
            <div key={classItem.classId} className='group mb-4 block'>
              <div className='space-y-2'>
                <div className='flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between'>
                  <div className='min-w-0 flex-1'>
                    <Link
                      to='/classes/$classId/enrolled-students'
                      params={{ classId: classItem.classId }}
                    >
                      <p className='truncate text-sm font-medium text-[#000814] transition-colors group-hover:text-[#FFC300]'>
                        {classItem.className}
                      </p>
                    </Link>
                  </div>
                  <div className='flex shrink-0 items-center gap-3'>
                    {/* <div className='flex items-center gap-1'>
                      {classItem.momentum > 0 ? (
                        <>
                          <TrendingUp className='size-3.5 text-green-600' />
                          <span className='text-xs font-medium text-green-600'>
                            +{classItem.momentum}%
                          </span>
                        </>
                      ) : classItem.momentum < 0 ? (
                        <>
                          <TrendingDown className='size-3.5 text-red-600' />
                          <span className='text-xs font-medium text-red-600'>
                            {classItem.momentum}%
                          </span>
                        </>
                      ) : (
                        <span className='text-xs font-medium text-slate-400'>
                          —
                        </span>
                      )}
                    </div> */}
                    <span className='text-sm tabular-nums text-[#6B7280]'>
                      {classItem.classFilledCount}/
                      {classItem.classTotalCapacity}
                    </span>
                    <span
                      className={cn(
                        'rounded-full px-2 py-0.5 text-xs font-semibold',
                        classItem.classOccupency < 25 &&
                          'bg-red-50 text-red-700',
                        classItem.classOccupency >= 30 &&
                          classItem.classOccupency < 70 &&
                          'bg-yellow-50 text-yellow-700',
                        classItem.classOccupency >= 70 &&
                          'bg-green-50 text-green-700',
                      )}
                    >
                      {classItem.classOccupency}%
                    </span>
                  </div>
                </div>
                <Progress
                  value={classItem.classOccupency}
                  className={cn(
                    'h-2',
                    classItem.classOccupency < 25 && '[&>div]:bg-red-500',
                    classItem.classOccupency >= 30 &&
                      classItem.classOccupency < 70 &&
                      '[&>div]:bg-yellow-500',
                    classItem.classOccupency >= 70 && '[&>div]:bg-green-500',
                  )}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
